import React from 'react'

const NumberInput = React.forwardRef((props, ref) => (
  <div className='row'>
    <label className='reconcile-label col-lg-4' htmlFor={props.name}>{props.label}</label>
    <div className='col-lg-7'>
      <input 
        className='form-control'
        type='number'
        step={0.01}
        ref={ref}
        name={props.name}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      {props.error && <div className='error_container'>{props.error.message}</div>}
    </div>
  </div>
))

export default NumberInput
